import { reloadData } from '@axo/form/data-access/backend-sync';
import { AnalyticsEvent } from '@axo/shared/services/analytics';
import type { DenmarkFormData } from '../FormData.dk.types';

type getTrackingDataArgs = {
  formData?: DenmarkFormData;
  step?: number;
  action?: 'Viewed' | 'Initiated' | 'Completed';
  customerId?: string;
};

export function getTrackingData(args: getTrackingDataArgs): AnalyticsEvent {
  const { formData, step, action, customerId } = args;

  const { applicationId } = reloadData.get();

  const tags = {
    feature: 'Form',
    step: !!step && `Step ${step}`,
    action,
  } as const;

  const event = Object.values(tags)
    .filter((tag) => !!tag)
    .join(' ');

  const params = {
    country: 'DK',
    customerId,
    loanApplicationID: applicationId,
    formCompletedTimestamp: new Date().toISOString(),
    appliedAmount: formData?.['LoanApplication/AppliedAmount'],
  };

  return {
    event,
    params,
  } as AnalyticsEvent;
}
